module.exports = __webpack_public_path__ + "static/img/member_item_price_icon.ee3c99a7.png";